import { render } from "./postsList.vue?vue&type=template&id=553a8ad3&scoped=true"
import script from "./postsList.vue?vue&type=script&lang=js"
export * from "./postsList.vue?vue&type=script&lang=js"

import "./postsList.vue?vue&type=style&index=0&id=553a8ad3&lang=css"
import "./postsList.vue?vue&type=style&index=1&id=553a8ad3&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553a8ad3"]])

export default __exports__